import script from "./Radiobox.vue?vue&type=script&setup=true&lang=js"
export * from "./Radiobox.vue?vue&type=script&setup=true&lang=js"

import "./Radiobox.vue?vue&type=style&index=0&id=7eae58ca&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eae58ca"]])

export default __exports__